import React, {useEffect} from 'react';
import {useDispatch, useSelector} from 'react-redux'
import {useParams} from 'react-router-dom';
import {useRoadmapService} from '../../services';
import DashboardDetails from "../DashboardNew/RoadMapDetails";
import {ENTITY, setCurrentEntity} from '../../redux/slices/timeline';

const ShareProject = () => {
  const { token } = useParams();
  const dispatch = useDispatch();
  const { fetchProjectShareData } = useRoadmapService();
  const { simulation } = useSelector((state: any) => state.timeline)

  useEffect(() => {
    if (token) {
      // Set entity to project level and fetch shared data
      dispatch(setCurrentEntity({ entity: ENTITY.PROJECT, entityId: token }));
      fetchProjectShareData(token, simulation);
    }
  }, [token, simulation]);

  return (
    <div className="row dark:bg-[#111928] w-full h-[100vh] !overflow-y-auto bg-gray-100 relative">
      {token && (
        <DashboardDetails readOnly />
      )}
    </div>
  )
}

export default ShareProject;